import useAnchoredPaginationParams from '@/hooks/requests/useAnchoredPaginationParams';
import { history, EventStatus, type AirdropProjectDTOS } from '@/apis/airdrops';
import { DEFAULT_PAGE_SIZE } from '@/constants/config';

import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

function useParticipatedList() {
  const [usedData, setUsedData] = useState<any>(undefined);

  const { params, onClickPrev, onClickNext } =
    useAnchoredPaginationParams(usedData);
  const { data, error, isLoading, isError } = useQuery({
    queryKey: ['participatedList', status, JSON.stringify(params)],
    queryFn: () =>
      history({
        prevId: params.prevId,
        nextId: params.nextId,
        pageSize: DEFAULT_PAGE_SIZE,
      }).then(({ data }) => {
        const hasNextPage =
          data.totalSize > DEFAULT_PAGE_SIZE &&
          params.page * DEFAULT_PAGE_SIZE < data.totalSize;
        const hasPrePage = params.page > 1;
        const nextId = hasNextPage
          ? data.airdropProjectUserRecordDTOList[data.airdropProjectUserRecordDTOList.length - 1].id
          : '';
        const prevId = hasPrePage ? data.airdropProjectUserRecordDTOList[0].id : '';

        console.log(hasNextPage, hasPrePage);
        setUsedData({
          ...data,
          nextId,
          prevId,
        });
        return {
          ...data,
          nextId,
          prevId,
        };
      }),
  });

  return { data, error, isLoading, isError, onClickPrev, onClickNext };
}
export default useParticipatedList;
